import React, { useState } from 'react'
import Icon from '@material-ui/core/Icon'
import { useSelector } from "react-redux";
import { Divider, Box, Typography, makeStyles, Tooltip } from '@material-ui/core';
import { getColorStyle, getTrendIcon, getTrendColor, getPreviousPeriodText  } from '../../../components/common/Common';
import { getMetric } from "../../../store/hub/conversionMetrics";
import ConversionDetailModal from "../../team-overview/components/team-header/ConversionDetailModal";

export default function UserStats ({ userId, metric1IdAndValue, metric2IdAndValue, canViewDetails }) {
  
  const classes = useStyles();
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [detailMetricName, setDetailMetricName] = useState(null);
  const [detailConversionMetricId, setDetailConversionMetricId] = useState(null);

  const metric1 = useSelector((state) => getMetric(state.entities.conversionMetrics, metric1IdAndValue.id));
  let metric2Id = null;
  if (metric2IdAndValue) {
    metric2Id = metric2IdAndValue.id;
  }
  const metric2 = useSelector((state) => getMetric(state.entities.conversionMetrics, metric2Id));

  try {
    return (
    
      <>
       
        <Divider style={{ width: "80%", marginLeft: "10%" }} />
        <Box className={classes.userStats}>
  
          {metric1 && (
            <Tooltip key={`user-metric-${userId}-${metric1.code}`} title={<div style={{ fontSize: '12px' }}>{getPreviousPeriodText(metric1IdAndValue)}</div>}>
              <Box
                className={`${classes.stats} ${canViewDetails ? classes.statClickable : ""}`}
                onClick={canViewDetails ? () => {
                  setDetailMetricName(metric1.name);
                  setDetailConversionMetricId(metric1IdAndValue.id);
                  setDetailModalOpen(true);
                } : undefined}
              >
                <Icon className={classes.icon} style={getColorStyle(getTrendColor(metric1IdAndValue))}>{getTrendIcon(metric1IdAndValue)}</Icon>
                <Typography variant="caption">{metric1IdAndValue.value}</Typography>
              </Box>
            </Tooltip>
            )}
  
          {metric2 && (
            <Tooltip key={`user-metric-${userId}-${metric2.code}`} title={<div style={{ fontSize: '12px' }}>{getPreviousPeriodText(metric2IdAndValue)}</div>}>
              <Box
                className={`${classes.stats} ${canViewDetails ? classes.statClickable : ""}`}
                onClick={canViewDetails ? () => {
                  setDetailMetricName(metric2.name);
                  setDetailConversionMetricId(metric2IdAndValue.id);
                  setDetailModalOpen(true);
                } : undefined}
              >
                <Icon className={classes.icon} style={getColorStyle(getTrendColor(metric2IdAndValue))}>{getTrendIcon(metric2IdAndValue)}</Icon>
                <Typography variant="caption">{metric2IdAndValue.value}</Typography>
              </Box>
            </Tooltip>
          )}
        </Box>
        {canViewDetails && (
          <ConversionDetailModal
            open={detailModalOpen}
            onClose={() => setDetailModalOpen(false)}
            metricName={detailMetricName}
            userId={userId}
            conversionMetricId={detailConversionMetricId}
          />
        )}
      </>
    );
  } catch (error) {
    return null;
  }
  
}

const useStyles = makeStyles((theme) => ({
  userStats: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  stats: {
    display: "inherit",
    flexDirection: "column",
    justifyContent: "space-evenly",
    textAlign: "center",
  },
  statClickable: {
    cursor: "pointer",
    borderRadius: 4,
    border: "2px solid transparent",
    "&:hover": {
      border: "2px solid rgba(0, 0, 0, 0.3)",
    },
  },
  icon: {
    marginLeft: "auto",
    marginRight: "auto",
  },
}));